import React from 'react';

import { SingleCheckConfigurationStatus } from 'components/widgets/LogicQualitySingleCheck/components/singleCheckConfigurationStatus/SingleCheckConfigurationStatus';
import classes from 'components/widgets/LogicQualitySingleCheck/components/validationOverview/ValidationOverview.module.scss';

interface Props {
    validationOverview: string | undefined;
    isIncludedInOverallScore: boolean | undefined;
    threshold: string | undefined;
}

export const ValidationOverview = ({ validationOverview, isIncludedInOverallScore, threshold }: Props) => {
    return (
        <div className={classes.validationOverview}>
            <div className={classes.title}>
                <h3>Validation overview</h3>
                <SingleCheckConfigurationStatus
                    isIncludedInOverallScore={isIncludedInOverallScore}
                    threshold={threshold}
                />
            </div>

            <p>{validationOverview}</p>
        </div>
    );
};
